import React, { useEffect } from 'react';
import AuthService from '../services/AuthService';
export default function Logout() {
  useEffect(() => { AuthService.logout().catch(() => { AuthService.logoutLocal(); window.location.hash = '#/login'; }); }, []);
  return <div className="section-panel text-center"><h1>Logging out...</h1></div>;
}
